var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insights_black_24dp 1",
    clipPath: "url(#clip0_1624_8472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.9998 13.334C32.5832 13.334 31.2332 15.734 31.7832 17.5173L25.8665 23.4507C25.3665 23.3007 24.6332 23.3007 24.1332 23.4507L19.8832 19.2007C20.4498 17.4173 19.0998 15.0007 16.6665 15.0007C14.2498 15.0007 12.8832 17.4007 13.4498 19.2007L5.84984 26.784C4.0665 26.234 1.6665 27.584 1.6665 30.0007C1.6665 31.834 3.1665 33.334 4.99984 33.334C7.4165 33.334 8.7665 30.934 8.2165 29.1507L15.7998 21.5507C16.2998 21.7007 17.0332 21.7007 17.5332 21.5507L21.7832 25.8006C21.2165 27.584 22.5665 30.0007 24.9998 30.0007C27.4165 30.0007 28.7832 27.6006 28.2165 25.8006L34.1498 19.884C35.9332 20.434 38.3332 19.084 38.3332 16.6673C38.3332 14.834 36.8332 13.334 34.9998 13.334Z",
    fill: "url(#paint0_linear_1624_8472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 15L26.5667 11.55L30 10L26.5667 8.45L25 5L23.4667 8.45L20 10L23.4667 11.55L25 15Z",
    fill: "url(#paint1_linear_1624_8472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83317 18.3333L6.6665 15L9.99984 14.1667L6.6665 13.3333L5.83317 10L4.99984 13.3333L1.6665 14.1667L4.99984 15L5.83317 18.3333Z",
    fill: "url(#paint2_linear_1624_8472)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_8472",
    x1: 31.0713,
    y1: 14.8924,
    x2: 24.904,
    y2: 36.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1624_8472",
    x1: 28.0195,
    y1: 5.77922,
    x2: 23.2143,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1624_8472",
    x1: 8.3494,
    y1: 10.6494,
    x2: 4.34508,
    y2: 18.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1624_8472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingIcon);
export default __webpack_public_path__ + "static/media/reporting-icon.ced8adfcfadfa93d1bb6455036915467.svg";
export { ForwardRef as ReactComponent };